import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';

import { BlockadesResponse, CreateBlockadeResponse } from '../../../store/api/blockades/blockades.types';
import { createBlockade, fetchBlockades } from '../../../store/api/blockades/blockadesActions';
import { EndpointsResponse } from '../../../store/api/endpoints/endpoints.types';
import { fetchEndpoints } from '../../../store/api/endpoints/endpointsActions';
import { submitForm } from '../../../store/api/submitForm/submitForm';

import { Endpoints } from './Endpoints';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onCreateBlockade: submitForm<CreateBlockadeResponse>(dispatch, createBlockade),
  onFetchBlockades: () => dispatch<Promise<BlockadesResponse>>(fetchBlockades()),
  onFetchEndpoints: () => dispatch<Promise<EndpointsResponse>>(fetchEndpoints()),
});

export const EndpointsContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(Endpoints);
